<template>
  <div class="wecom-loading">
    <div class="wecom-loading__spinner"></div>
    <p>{{ message }}</p>
  </div>
</template>

<script>
import { useUserStore } from '@/store/user'

export default {
  name: 'WecomLoginSuccess',
  data() {
    return { message: '正在登录...' }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const errorMsg = params.get('wecomError')

    if (errorMsg) {
      this.message = errorMsg
      setTimeout(() => this.$router.push('/login'), 2000)
      return
    }

    if (!token) {
      this.message = '登录失败：缺少认证信息'
      setTimeout(() => this.$router.push('/login'), 2000)
      return
    }

    const highestRole = params.get('highestRole')
    if (!highestRole) {
      this.message = '登录失败：认证信息不完整'
      setTimeout(() => this.$router.push('/login'), 2000)
      return
    }

    let orgScopes = []
    try {
      const orgScopesParam = params.get('orgScopes')
      if (orgScopesParam) orgScopes = JSON.parse(orgScopesParam)
    } catch (e) {
      console.warn('解析 orgScopes 失败，降级为空数组', e)
    }

    const userData = {
      token,
      userId: params.get('userId') || '',
      realName: params.get('realName') || '',
      highestRole,
      expiresIn: parseInt(params.get('expiresIn')) || 0,
      orgScopes
    }

    const userStore = useUserStore()
    userStore.setUser(userData)

    const roleHomeMap = {
      ADMIN: '/admin',
      CENTER_LEAD: '/',
      DEPT_LEAD: '/',
      MANAGER: '/control-tower-two'
    }

    const target = roleHomeMap[highestRole]
    if (!target) {
      this.message = '当前角色暂无可用页面'
      setTimeout(() => this.$router.push('/login'), 2000)
      return
    }
    this.$router.push(target)
  }
}
</script>

<style scoped>
.wecom-loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-family: "Aptos", "PingFang SC", "Microsoft YaHei UI", sans-serif;
  color: #1d2f2c;
  background: linear-gradient(135deg, #f8f4ec 0%, #f5efe5 100%);
}

.wecom-loading__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(41, 107, 115, 0.2);
  border-top-color: #296b73;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
